/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} News_And_BlogInputs */

const en_news_and_blog = /** @type {(inputs: News_And_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn`)
};

const th_news_and_blog = /** @type {(inputs: News_And_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรียนรู้`)
};

const ja_news_and_blog = /** @type {(inputs: News_And_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学ぶ`)
};

const fr_news_and_blog = /** @type {(inputs: News_And_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apprendre`)
};

const es_news_and_blog = /** @type {(inputs: News_And_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprender`)
};

const ru_news_and_blog = /** @type {(inputs: News_And_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обучение`)
};

const zh_news_and_blog = /** @type {(inputs: News_And_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学习`)
};

const vi_news_and_blog = /** @type {(inputs: News_And_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Học`)
};

/**
* | output |
* | --- |
* | "Learn" |
*
* @param {News_And_BlogInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const news_and_blog = /** @type {((inputs?: News_And_BlogInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<News_And_BlogInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_news_and_blog(inputs)
	if (locale === "ja") return ja_news_and_blog(inputs)
	if (locale === "fr") return fr_news_and_blog(inputs)
	if (locale === "es") return es_news_and_blog(inputs)
	if (locale === "ru") return ru_news_and_blog(inputs)
	if (locale === "zh") return zh_news_and_blog(inputs)
	if (locale === "vi") return vi_news_and_blog(inputs)
	return en_news_and_blog(inputs)
});